module.exports = __webpack_public_path__ + "img/phone.76cae4d7.svg";